import { Grid, Typography } from "@mui/material";
import React from "react";
import SummaryTable from "../SummaryTable";
import MainCard from "../../../components/MainCard";
import ResultChart from "../ResultChart";
import { CardType, ResultCard } from "../ResultCard";
import { StatsCard } from "./StatsCard";

const Summary = ({
  iteration,
  isLoading,
  totalTestCases,
  onNavigateToRequests = null,
}) => {
  return (
    <Grid container spacing={2} sx={{ alignItems: "stretch" }}>
      <Grid item xs={12}>
        <Grid container spacing={2} sx={{ alignItems: "stretch" }}>
          <Grid item xs={12} sm={6} md={2.4} sx={{ display: "flex" }}>
            <ResultCard
              isAPIReport={true}
              isLoading={isLoading}
              count={totalTestCases || iteration?.totalCount}
              cardType={"total"}
              onClick={() =>
                onNavigateToRequests && onNavigateToRequests("All")
              }
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2.4} sx={{ display: "flex" }}>
            <ResultCard
              isAPIReport={true}
              isLoading={isLoading}
              count={iteration?.passCount ?? 0}
              cardType={"success"}
              onClick={() =>
                onNavigateToRequests && onNavigateToRequests("Pass")
              }
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2.4} sx={{ display: "flex" }}>
            <ResultCard
              isAPIReport={true}
              isLoading={isLoading}
              count={iteration?.failCount ?? 0}
              cardType={"fail"}
              onClick={() =>
                onNavigateToRequests && onNavigateToRequests("Fail")
              }
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2.4} sx={{ display: "flex" }}>
            <ResultCard
              isAPIReport={true}
              isLoading={isLoading}
              count={iteration?.skipCount ?? 0}
              cardType={"skip"}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2.4} sx={{ display: "flex" }}>
            <ResultCard
              isAPIReport={true}
              isLoading={isLoading}
              count={(() => {
                const total = (iteration?.passCount ?? 0) + (iteration?.failCount ?? 0) + (iteration?.skipCount ?? 0);
                return total > 0 ? ((iteration.passCount / total) * 100).toFixed(1) : "0.0";
              })()}
              cardType={"rate"}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item md={6} xs={12} sx={{ display: "flex" }}>
        {iteration && (
          <SummaryTable isLoading={isLoading} iteration={iteration} />
        )}
      </Grid>
      <Grid item md={6} xs={12} sx={{ display: "flex" }}>
        {iteration && (totalTestCases || iteration?.totalCount) > 0 ? (
          <ResultChart
            isLoading={isLoading}
            passCount={iteration?.passCount ?? 0}
            failCount={iteration?.failCount ?? 0}
            skipCount={iteration?.skipCount ?? 0}
          />
        ) : (
          <MainCard
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}>
            <Typography variant="body1" align="center">
              No data available.
            </Typography>
          </MainCard>
        )}
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={2} sx={{ alignItems: "stretch" }}>
          <Grid item xs={12} md={3} sx={{ display: "flex" }}>
            <StatsCard
              isLoading={isLoading}
              values={[
                (iteration?.timeStats?.averageResponseTime ?? 0).toFixed(2),
              ]}
              cardType={"avgRespTime"}
            />
          </Grid>
          <Grid item xs={12} md={3} sx={{ display: "flex" }}>
            <StatsCard
              isLoading={isLoading}
              values={[iteration?.timeStats?.minResponseTime ?? 0]}
              cardType={"minRespTime"}
            />
          </Grid>
          <Grid item xs={12} md={3} sx={{ display: "flex" }}>
            <StatsCard
              isLoading={isLoading}
              values={[iteration?.timeStats?.maxResponseTime ?? 0]}
              cardType={"maxRespTime"}
            />
          </Grid>
          <Grid item xs={12} md={3} sx={{ display: "flex" }}>
            <StatsCard
              isLoading={isLoading}
              values={[iteration?.timeStats?.responseTimeStdDev ?? 0]}
              cardType={"respStdDev"}
            />
          </Grid>
          <Grid item xs={12} md={4} sx={{ display: "flex" }}>
            <StatsCard
              isLoading={isLoading}
              values={[
                iteration?.assertions?.total ?? 0,
                iteration?.assertions?.failed ?? 0,
              ]}
              cardType={"assertion"}
            />
          </Grid>
          <Grid item xs={12} md={4} sx={{ display: "flex" }}>
            <StatsCard
              isLoading={isLoading}
              values={[
                iteration?.preRequestScripts?.total ?? 0,
                iteration?.preRequestScripts?.failed ?? 0,
              ]}
              cardType={"preRequestScripts"}
            />
          </Grid>
          <Grid item xs={12} md={4} sx={{ display: "flex" }}>
            <StatsCard
              isLoading={isLoading}
              values={[
                iteration?.postResponseScripts?.total ?? 0,
                iteration?.postResponseScripts?.failed ?? 0,
              ]}
              cardType={"postResponseScripts"}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Summary;
